export interface UIModel {
  overview: {
    leftPanel: LeftPanel;
    mainPanel: MainPanel;
    rightPanel: RightPanel;
  };
  zoom: number;
}

export enum LeftPanel {
  FILES,
  GROUPS
}

export enum MainPanel {
  NONE,
  TABLE,
  TABLE_TITLES,
  FIGURE
}

export enum RightPanel {
  NONE,
  ASSIGN_TO_CHECK,
  CHECK_LIST,
  FILTER_PANEL,
  RESOLUTION_NOTES,
  LABELING,
  TLF_INFO
}

export interface ITab {
  selected: boolean;
  name?: string;
  disabled?: boolean;
}

export interface IChartModifiedFileData {
  all: number[];
  title: number[];
  body: number[];
  footnotes: number[];
  figures: number[];
}

export interface ISideTab extends ITab {
  type: RightPanel;
  icon: string;
  permission: string;
  disabled?: boolean;
  display?: boolean;
  badge?: number;
  title?: string;
}

export interface MatSelectOption {
  value?: number | string;
  label?: string;
  disabled?: boolean;
  key?: string;
}

export interface LabelItem {
  value?: number | string;
  label?: string;
  key?: string;
  index?: number;
}
